import React from 'react';
import { useCounter } from '../hooks/useAnimations';
import { stats } from '../data/siteData';

const StatItem = ({ value, label, suffix }) => {
  const [ref, count] = useCounter(value);
  return (
    <div ref={ref} style={{ textAlign: 'center', padding: '28px 16px' }}>
      <div style={{ fontSize: '2.8rem', fontWeight: 800, color: 'var(--gold)', fontFamily: 'var(--fh)', lineHeight: 1 }}>
        {count}{suffix}
      </div>
      <div style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.6)', marginTop: 8, letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 500 }}>
        {label}
      </div>
    </div>
  );
};

const StatsBar = () => (
  <section className="sec-navy">
    <div className="container" id="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8 }}>
      {stats.map((s, i) => <StatItem key={i} {...s} />)}
    </div>
    <style>{`@media(max-width:768px){#stats-grid{grid-template-columns:1fr 1fr!important;}}`}</style>
  </section>
);

export default StatsBar;
